import React from 'react';
import { styled, StyledProps } from '@glitz/react';
import Price from 'Pricing/Price';
import CheckoutLabels from '../Pages/Checkout/CheckoutPageViewModel+CheckoutLabels.type';
import Payment from '../Pages/Checkout/PaymentModel.type';
import { ResponsiveSize, TextBlockSmall } from 'Shared/SharedComponents/atoms/Typography';
import * as style from 'Shared/Style';

const Row = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
});

const ShipmentRow = styled(Row, {
  marginBottom: '8px'
})

const VatRow = styled(Row, {
  marginBottom: '8px'
})

const TotalsRow = styled(Row, {
  textTransform: 'uppercase', marginTop: '16px', fontSize: '24px'
})

const TotalsToPay = styled.span({
  fontWeight: 500
})

const DiscountNames = styled.span({
  textAlign: 'right',
  paddingRight: '8px'
});

const MarginBottomRow = styled(Row, {
  marginBottom: '8px'
})

const CartInformationRow = styled(Row, {
  padding: { xy: '8px' },
  justifyContent: 'left',
  alignItems: 'center',
  borderRadius: '8px',
  gap: '8px',
  backgroundColor: style.hex2rgba(style.colors.brandColors.green, 0.3),
  width: '100%',
  ['@media ' + style.mediaMinLarge]: {
    justifyContent: 'center',
  },
})

const CartInformationLine = styled.span({
  display: 'block',
  textAlign: 'center'
})

type PropType = StyledProps & {
  isMobile: boolean;
  labels: CheckoutLabels;
  totalToPay: number;
  totalSavings: number;
  shippingTotal: number;
  payment: Payment;
  cartInformation: string[];
};

const Summary = (props: PropType) => (
  <styled.Div css={props.compose()}>
    <ShipmentRow>
      <span>{props.labels.shipment}</span>
      <span>
        <Price sellingPrice={props.shippingTotal} fontSize={16}></Price>
      </span>
    </ShipmentRow>

    {props.totalSavings > 0 && (
      <MarginBottomRow>
        <span>{props.payment.labels.totalDiscount}</span>
        <span>
          {props.payment.discountNames && props.payment.discountNames.length > 0 && (
            <DiscountNames>({props.payment.discountNames.join(', ')})</DiscountNames>
          )}
          <Price subtraction sellingPrice={props.totalSavings} fontSize={16} />
        </span>
      </MarginBottomRow>
    )}
    {/* {props.payment.bonusChecksInCart.map((bonusCheckInCart, index) => (
      <MarginBottomRow key={index}>
        <RowTextCell>{props.payment.labels.bonusCheck}</RowTextCell>
        <RightAlignedRowTextCell><Price subtraction sellingPrice={bonusCheckInCart.amount} fontSize={16} /></RightAlignedRowTextCell>
      </MarginBottomRow>
    ))}
    {props.payment.secondHandChecksInCart.map((secondHandCheckInCart, index) => (
      <MarginBottomRow key={index}>
        <RowTextCell>{props.payment.labels.secondHandCheck}</RowTextCell>
        <RightAlignedRowTextCell><Price subtraction sellingPrice={secondHandCheckInCart.amount} fontSize={16} /></RightAlignedRowTextCell>
      </MarginBottomRow>
    ))} */}
    {props.payment.giftCardPayments.map((giftCardPayment, index) => (
      <MarginBottomRow key={index}>
        <span>{props.payment.labels.giftCard}</span>
        <span><Price subtraction sellingPrice={giftCardPayment.amount} fontSize={16} /></span>
      </MarginBottomRow>
    ))}
    {props.payment.showVat && (
      <VatRow>
        <span>{props.payment.labels.vat}</span>
        <span>
          <Price sellingPrice={props.payment.vatAmount} fontSize={16} />
        </span>
      </VatRow>
    )}
    {props.cartInformation && props.cartInformation.length > 0 && (
      <CartInformationRow>
        {/* <Truck /> */}
        <TextBlockSmall fontSize={ResponsiveSize.D12_M12}>
          {props.cartInformation.map((ci, index) => {
            return (<CartInformationLine key={index}>{ci}</CartInformationLine>);
          })}
        </TextBlockSmall>
      </CartInformationRow>
    )}
    <TotalsRow>
      <TotalsToPay>{props.payment.labels.toPay}</TotalsToPay>
      <span>
        <Price sellingPrice={props.totalToPay} listPrice={props.totalToPay} fontSize={24}></Price>
      </span>
    </TotalsRow>
  </styled.Div>
);

export default styled(Summary, {});
